import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEndCall = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.66167 3.8165L8.68386 6.28647C8.86275 6.69813 8.76053 7.18698 8.40276 7.47L7.15058 8.52488C7.45723 9.1681 7.84056 9.7856 8.30054 10.3259L17.1936 3.32765C17.4491 3.09609 17.8325 3.14755 18.0369 3.43057C18.2669 3.68786 18.2158 4.07379 17.9347 4.27962L2.80627 16.2178C2.55072 16.4494 2.1674 16.3979 1.96296 16.1149C1.73296 15.8576 1.78407 15.4717 2.06518 15.2658L6.02617 12.1269C4.41622 10.1201 3.47069 7.59864 3.47069 4.81993C3.47069 4.35681 3.77735 3.97087 4.21178 3.84223L6.4606 3.22474C6.94614 3.09609 7.48279 3.32765 7.66167 3.8165ZM10.1405 12.024C10.4983 12.2556 10.856 12.4614 11.2393 12.6415L12.2871 11.3808C12.5682 11.0206 13.0537 10.9177 13.4626 11.0978L15.9159 12.1269C16.4014 12.307 16.6314 12.8473 16.5036 13.3362L15.8903 15.6003C15.7625 16.0377 15.3792 16.3465 14.9192 16.3465C12.236 16.3465 9.75716 15.4202 7.815 13.8765L10.1405 12.024Z",
		fill: "currentColor"
	})
});
export default SvgEndCall;
